var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanningDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 119,
    viewBox: "0 0 166 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.5 113.499C126.5 116.539 106.577 119 82.0009 119C57.4233 119 37.5 116.539 37.5 113.499C37.5 110.461 57.4233 108 82.0009 108C106.577 108 126.5 110.461 126.5 113.499Z",
    fill: "#05C3DE",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.842 0C41.9987 0 8.07666 33.9318 8.07666 75.7871C8.07666 86.9373 10.503 97.5152 14.8273 107.049H152.857C157.181 97.5152 159.607 86.9373 159.607 75.7871C159.607 33.9318 125.685 0 83.842 0Z",
    fill: "#05C3DE",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02344 107.049H156.766",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 107.049H5.23533",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.554 107.049H165.29",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.833 106.667C113.833 108.692 112.192 110.333 110.167 110.333H55.1667C53.1416 110.333 51.5 108.692 51.5 106.667V29.6667C51.5 27.6416 53.1416 26 55.1667 26H90.33C91.3062 25.9973 92.2432 26.384 92.9333 27.0743L112.785 46.9257C113.472 47.6132 113.859 48.5456 113.859 49.518L113.833 106.667Z",
    fill: "white",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8335 26.3301V44.3334C91.8335 46.3585 93.4751 48.0001 95.5002 48.0001H113.503",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8335 26.3301V44.3334C91.8335 46.3585 93.4751 48.0001 95.5002 48.0001H113.503",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8188 84.667H102.848",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5732 73.667H102.848",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8481 62.667H102.848",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8188 95.667H102.848",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3335 44.333H67.8938C65.5375 44.3347 63.5131 46.0064 63.066 48.3199C62.6188 50.6334 63.8745 52.9391 66.0605 53.8187L73.6285 56.8473C75.8144 57.7269 77.0701 60.0326 76.6229 62.3461C76.1758 64.6596 74.1514 66.3314 71.7951 66.333H64.3335",
    stroke: "#05C3DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8481 44.3337V40.667",
    stroke: "#05C3DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8481 69.9997V66.333",
    stroke: "#05C3DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.017 112.725C123.12 112.725 130.5 105.345 130.5 96.2413C130.5 87.1377 123.12 79.7578 114.017 79.7578C104.913 79.7578 97.5332 87.1377 97.5332 96.2413C97.5332 105.345 104.913 112.725 114.017 112.725Z",
    fill: "white",
    stroke: "#086EA1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.267 88V104.484",
    stroke: "#05C3DE",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.775 96.2412H122.258",
    stroke: "#05C3DE",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningDetails);
export default __webpack_public_path__ + "static/media/planning-details.11d581821428583244556e1709ff49f3.svg";
export { ForwardRef as ReactComponent };